/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccidentReviewDocumentDocumentTypeDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: AccidentReviewDocumentDocumentTypeDefinitionDto.source;
    label?: string;
}

export namespace AccidentReviewDocumentDocumentTypeDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
